import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const USER_KEY  = 'lead_user';
const TOKEN_KEY = 'lead_token';

@Injectable({ providedIn: 'root' })
export class AuthStateService {
  private platformId = inject(PLATFORM_ID);
  private get isBrowser(): boolean { return isPlatformBrowser(this.platformId); }

  saveSession(data: { result: any; token: string }): void {
    if (!this.isBrowser) return;
    localStorage.setItem(USER_KEY,  JSON.stringify(data.result));
    localStorage.setItem(TOKEN_KEY, data.token);
  }

  getToken(): string | null {
    if (!this.isBrowser) return null;
    return localStorage.getItem(TOKEN_KEY);
  }

  getUser(): any | null {
    if (!this.isBrowser) return null;
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  clearSession(): void {
    if (!this.isBrowser) return;
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
  }
}